/**
 * @generated SignedSource<<28848584022bcdb8ea2ef29b4911c862>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutAddressView_address$data = {
  readonly company: string | null;
  readonly displayCountry: string | null;
  readonly displayName: string | null;
  readonly formattedAddress: ReadonlyArray<string | null> | null;
  readonly phoneNumber: string | null;
  readonly " $fragmentType": "CheckoutAddressView_address";
};
export type CheckoutAddressView_address$key = {
  readonly " $data"?: CheckoutAddressView_address$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddressView_address">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutAddressView_address",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayCountry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    }
  ],
  "type": "Address",
  "abstractKey": null
};

(node as any).hash = "08d84798531d3261e760816398ee45ca";

export default node;
